document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict();

	var lastScrollTop = 0;
	
	$(window).scroll(function(e) {    
		var scroll = $(window).scrollTop();
		var HeroHeader = $('.sticky-header');
		var st = $(this).scrollTop();

		if (scroll >= 0) {
			$(HeroHeader).addClass("onScroll");
		} else {
			$(HeroHeader).removeClass("onScroll");
		}

		if (st > lastScrollTop) {
			$(HeroHeader).removeClass("onScrollUp");
		} else {
			$(HeroHeader).addClass("onScrollUp");
		}

		lastScrollTop = st;

		if (scroll >= 94) {
			$('.scroll-up').removeClass('hidden');
			$('.site-header').addClass('static');
			$('.list-menu').addClass('sticky');
		} else {
			$('.scroll-up').addClass('hidden');
			$('.site-header').removeClass('static');
			$('.list-menu').removeClass('sticky');
		}
	});

	setTimeout(function() {
		$('.acf-form-sent').text('');
		if ( $('.acf-form-sent').hasClass('acf-form-sent') ) {
			history.replaceState(null, null, ' ');
		}
	}, 2000);

	// Scroll Up button
	$('.scroll-up').click(function(e) {
		page.animate({
			scrollTop : 0,
		}, 100);
		e.preventDefault();
	});

	// Scroll Down button
	$('.scroll-down').click(function(e) {
		var SlideHeight = $('.hero-home').height();
		// /console.log(SlideHeight);
		page.animate({
			scrollTop : page.scrollTop() + SlideHeight,
		}, 100);
		e.preventDefault();
	});
});